<template>
  <section class="minimized-call minimized-call-no-height" v-if="shouldPresent"
    v-bind:class="{'pill-collapse': isCollapsed}" :style="`top: calc(${0.25*$vnode.key}rem + 65px);`"
  >
    <div v-if="activeState && activeRequest && hasStartedCountingTime"
         :class="{'row near-end-bar near-end-yellow': secondsRemainToEnd < 600 && secondsRemainToEnd > 300, 'row near-end-bar near-end-red': secondsRemainToEnd < 300}"/>
    <div class="collapsable-div">
      <i v-if="isCollapsed" class="fa fa-chevron-left clickable" v-on:click="handleCollapse"></i>
      <i v-else class="fa fa-chevron-right clickable" v-on:click="handleCollapse"></i>
    </div>

    <div class="appointment-call-minimized default" v-show="activeRequest === null && userIsActiveAudiologist" key="2">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center">
          <small class="is-bold text-small">{{ $t('evocall.requests.activity_state') }}:</small>
          <small class="is-bold text-small ml-4">{{
              inBreak ? $t('evocall.requests.activity_state_suspended') : $t('evocall.requests.activity_state_active')
            }}</small>
          <Slider class="ml-4" :disabled="isTogglingBreak" :checked="!inBreak" @change="toggleBreak"></Slider>
        </div>
        <div class="d-flex align-items-center pt-3 pl-4">
          <div class="d-flex">
            <va-popover
              placement="top"
              :message="$t('evocall.dashboard.online_audiologists')">
              <i class="i-waiting-room-online-audiologists svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ onlineAudiologists }} </span>
            </va-popover>
          </div>


          <div class="ml-4 d-flex">
            <va-popover
              placement="top"
              :message="$t('evocall.dashboard.on_going')">
              <i class="i-waiting-room-in-consultation svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ metrics.ongoingCalls }} </span>
            </va-popover>

          </div>


          <div class="ml-4 d-flex">
            <va-popover
              placement="top"
              :message="$t('evocall.dashboard.waiting_time')">
              <i class="i-waiting-room-waiting svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ requests.length }} </span>
            </va-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="appointment-call-minimized active" v-if="activeState && activeRequest" key="4">
      <div class="call-wrapper">
        <div class="call-informations-wrapper">
          <div class="call-informations">

            <div class="container_call">
              <!--Left div-->
              <div class="info_call_left">
                <!-- Top left line-->
                <div class="d-flex flex-column align-items-center info_call_left_top">
                  <span>{{ $t('clinical.appointments.in_call_with') | upperCase }}</span>
                </div>

                <!-- Bottom left line-->
                <div class="d-flex flex-column align-items-center info_call_left_bottom">
                  <span> {{ activeRequest.customerName }} </span>
                  <small class="call-user">{{ userIsAcceptee ? creator : acceptee }}</small>
                </div>
              </div>

              <!-- Right div/Right line-->
              <div class="d-flex flex-column align-items-center info_call_right">

              </div>
            </div>

            <div class="call-duration" v-if="callDuration !== null">
              <span>{{ getDurationString(callDuration.asSeconds(), 'seconds', true, ' : ', false) }}</span>
            </div>
          </div>

          <div class="call-actions" v-if="userIsAcceptee">
            <span>{{ $t('evocall.requests.estimated_duration') }}:
              <span
                :class="{'near-end-yellow-text': secondsRemainToEnd < 600 && secondsRemainToEnd > 300, 'near-end-red-text': secondsRemainToEnd < 300}">
                {{ secondsRemainToEnd > 300 ? `${activeRequest.estimatedDuration} min.` : $t('evocall.requests.5_min_remaining') }}
              </span>
              <i v-if="secondsRemainToEnd < 600"
                 :class="{'fa fa-warning near-end-yellow-text': secondsRemainToEnd < 600 && secondsRemainToEnd > 300, 'fa fa-warning near-end-red-text' : secondsRemainToEnd < 300}"></i>
            </span>
            <!--<span :class="{'near-end': isNearEnd}"> {{ activeRequest.call.estimated_duration }} min.</span>&nbsp;-->
            <!--<i v-if="isNearEnd" class="fa fa-warning near-end"></i></span>-->

            <div class="call-action-buttons">
              <va-popover
                placement="bottom"
                :message="$t('evocall.requests.actions.update_estimated_duration')"
                :popoverClasses="['evollu-color']"
                :popoverStyles="{'border-radius': 0, 'color': 'white'}"
                backgroundColor="#29c4a9">
                <i class="fa fa-clock-o" @click.prevent="onClickUpdateEstimatedDuration"></i>
              </va-popover>
              <va-popover
                placement="bottom"
                :message="$t('evocall.requests.actions.requeue')"
                :popoverClasses="['evollu-color']"
                :popoverStyles="{'border-radius': 0, 'color': 'white'}"
                backgroundColor="#29c4a9">
                <i class="fa fa-history" @click.prevent="onClickRequeueCall"></i>
              </va-popover>

            </div>

          </div>

          <div class="d-flex align-items-center pt-3 pl-4" v-if="userIsAcceptee">
            <div class="d-flex">
              <va-popover
                placement="top"
                :message="$t('evocall.dashboard.online_audiologists')">
                <i class="i-waiting-room-online-audiologists svg-kpi"></i>&nbsp;
                <span class="kpi-content">  {{ onlineAudiologists }} </span>
              </va-popover>
            </div>


            <div class="ml-4 d-flex">
              <va-popover
                placement="top"
                :message="$t('evocall.dashboard.on_going')">
                <i class="i-waiting-room-in-consultation svg-kpi"></i>&nbsp;
                <span class="kpi-content">  {{ metrics.ongoingCalls }} </span>
              </va-popover>

            </div>


            <div class="ml-4 d-flex">
              <va-popover
                placement="top"
                :message="$t('evocall.dashboard.waiting_time')">
                <i class="i-waiting-room-waiting svg-kpi"></i>&nbsp;
                <span class="kpi-content">  {{ requests.length }} </span>
              </va-popover>
            </div>
          </div>

        </div>

        <div class="end-call-wrapper">
          <va-popover
            placement="left"
            :message="$t('clinical.appointments.dismiss_call')"
          >
            <va-button
              id="btn-dismiss"
              large
              class="va-button-rounded"
              icon="fa fa-phone"
              @click="onClickEndCall"
            >
            </va-button>

          </va-popover>

        </div>

      </div>
    </div>

    <ConfirmationModal
      v-if="confirmationModalOptions.display"
      :title="undefined"
      :body="confirmationModalOptions.message"
      @modal-confirmed="modalConfirmed"
      @modal-canceled="resetConfirmationModals"
    />

    <RateCallRequest
      v-if="showRateModal && unratedRequests.length > 0"
      :request="unratedRequests[0]"
      :memberType="userIsActiveAudiologist ? 'audiologist' : 'dispenser'"
      @rate-submitted="onRateSubmitted"
    />

    <UpdateEstimatedDuration
      v-if="isUpdatingEstimatedDuration"
      :request="activeRequest"
      @request-updated="onEstimatedDurationUpdated"
      @cancel="onUpdateEstimatedDurationModalClosed"
    />
  </section>
</template>

<script>
  import * as _ from "lodash";
  import {mapActions, mapGetters, mapState} from "vuex";
  import Slider from '@/components/common/Slider'
  import RelativeTimeMixin from "@/mixins/RelativeTimeMixin";
  import CurrentLocaleMixin from "@/mixins/CurrentLocaleMixin";
  import SocketioService from "@/services/socketio.service";
  import EventBus from "@/utils/EventBus";
  import {BreaksService, RequestService} from "@/api/VirtualWaitingRoomService";
  import ConfirmationModal from "@/components/common/ConfirmationModal";
  import RateCallRequest from "@/components/virtual_waiting_room/rate/RateCallRequest";
  import UpdateEstimatedDuration from "@/components/virtual_waiting_room/waiting_room/UpdateEstimatedDuration";

  const ESTIMATED_REQUEST_DURATION = 25

  export default {
    components: {
      UpdateEstimatedDuration,
      RateCallRequest,
      ConfirmationModal,
      Slider,
    },
    mixins: [
      RelativeTimeMixin,
      CurrentLocaleMixin
    ],
    data() {
      return {
        isUpdatingEstimatedDuration: false,
        hasStartedCountingTime: false,
        callDuration: null,
        secondsRemainToEnd: null,
        isTogglingBreak: false,
        confirmationModalOptions: {
          message: null,
          action: null,
          display: false
        },
        estimatedTimeToAcceptance: null,
        estimatedTimeTicker: null,
        callDurationTicker: null,
        unratedRequests: [],
        showRateModal: false
      }
    },
    beforeCreate() {
      SocketioService.getMetrics(this.$auth.user().id)
    },
    created: async function () {
      SocketioService.getActiveRequest()
      this.loadAuthUserEntityActivityRecords()
      await this.handleUnratedRequestsGet()

      EventBus.$on('rate-request-after-end', async () => {
        await this.handleUnratedRequestsGet()
      })
    },
    methods: {
      ...mapActions('auth', {
        loadAuthUserEntityActivityRecords: 'LOAD_AUTH_USER_ENTITY_ACTIVITIES'
      }),
      handleUnratedRequestsGet: async function () {
        this.unratedRequests = await RequestService.unratedRequests()
        if (this.unratedRequests.length > 0) {
          this.showRateModal = true
        }
      },
      updateCallDuration: function () {
        this.callDuration = this.moment.duration(this.moment().diff(this.activeRequest.startedAt))
        if (this.activeRequest) {
          this.secondsRemainToEnd = this.activeRequest.estimatedDuration * 60 - this.callDuration.asSeconds()
          this.isNearEnd = this.activeRequest.estimatedDuration / 60 - this.callDuration.asSeconds() < 600
          if (!this.hasStartedCountingTime && this.secondsRemainToEnd > 1) {
            this.hasStartedCountingTime = true
          }
        }
      },
      onEstimatedDurationUpdated: function () {
        this.isUpdatingEstimatedDuration = false
      },
      onUpdateEstimatedDurationModalClosed: function () {
        this.isUpdatingEstimatedDuration = false
      },
      onClickUpdateEstimatedDuration: function () {
        this.isUpdatingEstimatedDuration = true
      },
      onClickRequeueCall: function () {
        this.confirmationModalOptions = {
          message: this.$t('evocall.requests.actions.confirm_requeue'),
          action: 'requeue',
          display: true
        }
      },
      handleCollapse: function () {
        this.$store.commit(`${this.waitingRoomModuleKey}/HANDLE_MINIMIZED_CALL_COLLAPSED`)
      },
      toggleBreak: function () {
        if (!this.isTogglingBreak) {
          this.isTogglingBreak = true
          let request = null
          let successCallBack = null

          if (this.activeBreak === null) {
            request = BreaksService.start()
            successCallBack = (_break) => {
              this.$store.commit(`${this.waitingRoomModuleKey}/SET_ACTIVE_BREAK`, {_break})
            }
          } else {
            request = BreaksService.stop(this.activeBreak.id)
            successCallBack = (_break) => {
              this.$store.commit(`${this.waitingRoomModuleKey}/RESET_ACTIVE_BREAK`)
            }
          }

          request
            .then(successCallBack)
            .catch(errors => {
              this.showToast(this.$t('evocall.requests.something_went_wrong'), this.$store.state.errorToastOptions)
            })
            .finally(() => {
              this.isTogglingBreak = false
            })
        }
      },
      onClickEndCall: function () {
        this.confirmationModalOptions = {
          message: this.$t('clinical.people.appointments.end_call_confirmation_message'),
          action: 'endCall',
          display: true
        }
      },
      modalConfirmed: function () {
        switch (this.confirmationModalOptions.action) {
          case 'requeue':
            this.confirmRequeue()
            break
          case 'endCall':
            this.confirmEndCall()
            break
        }
        this.resetConfirmationModals()
      },
      resetConfirmationModals: function () {
        this.confirmationModalOptions = {
          message: null,
          action: null,
          display: false
        }
      },
      confirmRequeue: function () {
        if (this.activeRequest) {
          RequestService.requeue(this.activeRequest.id)
            .then(req => {

            })
        }
      },
      confirmEndCall: function () {
        if(this.activeRequest) {
          RequestService.end(this.activeRequest.id, this.userIsAcceptee ? 'audiologist' : 'dispenser')
            .then(response => {
              this.$forceUpdate()
            })
            .catch(errors => {
              this.showToast(this.$t('clinical.appointments.end_call_request_failed'), this.$store.state.errorToastOptions)
            })
        }
      },
      clearCallDurationVariables: function () {
        if (this.callDurationTicker !== null) {
          clearInterval(this.callDurationTicker)
          this.callDurationTicker = null
          this.callDuration = null
        }
      },
      clearEstimatedTimeVariables: function () {
        if (this.estimatedTimeTicker !== null) {
          clearInterval(this.estimatedTimeTicker)
          this.estimatedTimeTicker = null
          this.estimatedTimeToAcceptance = null
        }
      },
      onRateSubmitted: function() {
        //close the modal, remove the request from index 0 of unrated requests, check if there are more, if so, show the modal again
        this.showRateModal = false
        this.unratedRequests.shift()
        setTimeout(() => {
          if(this.unratedRequests.length > 0) {
            this.showRateModal = true
          }
        }, 1000)

      },
    },
    computed: {
      waitingRoomModuleKey: function () {
        return `virtualWaitingRoom`
      },
      ...mapGetters({
        userIsActiveAudiologist: 'auth/userIsActiveAudiologist'
      }),
      ...mapState({
        activeRequest(state, getters) {
          return getters[`${this.waitingRoomModuleKey}/activeRequest`] || null
        },
        isCollapsed(state) {
          return state[this.waitingRoomModuleKey].minimizedCallCollapsed
        },
        inBreak(state, getters) {
          return getters[`${this.waitingRoomModuleKey}/inBreak`] || null
        },
        activeBreak(state, getters) {
          return getters[`${this.waitingRoomModuleKey}/activeBreak`] || null
        },
        requests(state, getters) {
          return getters[`${this.waitingRoomModuleKey}/requests`]
        },
        metrics(state, getters) {
          return getters[`${this.waitingRoomModuleKey}/metrics`] || null
        },
        onlineAudiologistsResume (state, getters) {
          return getters[`${this.waitingRoomModuleKey}/onlineAudiologists`] || null
        }
      }),
      onlineAudiologists: function (value) {
        return this.onlineAudiologistsResume ? this.onlineAudiologistsResume.online : 0
      },
      audiologistsInBreak: function () {
        return this.onlineAudiologists !== undefined ? this.onlineAudiologists.inBreak : 0
      },
      shouldPresent: function () {
        return (this.userIsActiveAudiologist)
      },
      callHasBeenAccepted: function () {
        return _.get(this.activeRequest, 'startedAt', null) !== null
      },
      callHasEnded: function () {
        return _.get(this.activeRequest, 'endedAt', null) !== null
      },
      activeState: function () {
        return this.activeRequest !== null && this.callHasBeenAccepted && !this.callHasEnded
      },
      acceptee: function () {
        return _.get(this.activeRequest, 'acceptedBy', null)
      },
      userIsAcceptee: function () {
        return this.acceptee !== null && this.acceptee === this.$auth.user().id
      },
      creator: function () {
        return _.get(this.activeRequest, 'dispenserNickname', null)
      },
    },
    beforeDestroy: function () {
      this.clearCallDurationVariables()
      this.clearEstimatedTimeVariables()
    },
    watch: {
      callHasBeenAccepted: {
        handler: function (value) {
          if (value) {
            if (this.callDurationTicker === null) {
              this.callDurationTicker = setInterval(this.updateCallDuration, 1000)
            }
          } else {
            this.clearCallDurationVariables()
          }
        },
        immediate: true
      },
      estimatedTimeUntilAcceptance: {
        handler: function (value) {
          if (value !== null) {
            if (this.estimatedTimeTicker === null) {
              this.estimatedTimeTicker = setInterval(this.updateEstimatedTimeToAcceptance, 1000)
            }
          } else {
            this.clearEstimatedTimeVariables()
          }
        },
        immediate: true
      },
      activeRequest: function (value) {
        if (value === null) {
          this.clearCallDurationVariables()
        }
      },
    }
  }
</script>

<style lang="scss">

@mixin mobile {
  @media (max-width: 768px) {
    @content;
  }
}

.svg-kpi {
  filter: invert(46%) sepia(13%) saturate(9%) hue-rotate(23deg) brightness(90%) contrast(99%);
}

.kpi-content {
  font-size: 1.25rem;
  font-weight: bold;
  vertical-align: text-bottom;
}

//--- CSS for information displayed on pending appointment ---
.container_call {
  display: flex;
  width: 100%
}

.info_call_left {
  flex: 1.5;
  display: flex;
  flex-direction: column
}

.info_call_left_top {
  flex: 1;
}

.info_call_left_bottom {
  flex: 1;
}

.info_call_right {
  flex: .1;
  align-self: center;
  padding-right: 15px
}

//---END of CSS for information displayed on pending appointment ---

.collapsable-div {
  position: fixed;
  height: 8rem;
  display: flex;
  align-items: center;
  padding-left: 0.35rem;

  i {
    font-size: 24px;
    color: $evollu-dark;
  }
}
.minimized-call-no-height {
  height: unset !important;
}
.minimized-call {
  position: fixed;
  height: 8rem;
  right: 0;
  z-index: 9;
  transition: 0.7s;
  top: 65px;

  .near-end-bar {
    height: 10px;
    margin: 0 !important;
  }

  .near-end-yellow {
    background: #c49d29;
  }

  .near-end-yellow-text {
    color: #c49d29;
  }

  .near-end-red {
    background: #c5253a;
  }

  .near-end-red-text {
    color: #c5253a;
  }

  &.pill-collapse {
    transform: translateX(95%);
  }

  &.not-in-correct-active-appointment {
    .appointment-call-minimized {
      background-color: rgb(255, 145, 0) !important;
      color: white;
    }

    .text-success {
      color: white !important;
    }

    .collapsable-div {
      i {
        color: white;
      }
    }

  }

  .appointment-call-minimized {
    padding: 1rem;
    border-bottom-left-radius: 3rem;
    -moz-box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);;
    -webkit-box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);;
    box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);
    display: flex;
    height: 100%;

    &.default {
      background-color: #eee;
      width: 22.5vw;
      justify-content: center;
      align-items: center;

      .active-appointment-warning {
        padding: 0rem 1.25rem;
        text-align: center;
        cursor: pointer;

        &:hover {
          font-weight: bold;
          color: $evollu-dark;
        }
      }

      #btn-create-request {
        padding: 1.5rem !important;
      }
    }

    &.pending {
      background-color: #eee;
      width: 35vw;
      padding-left: 3.5rem;
      justify-content: flex-start;
      align-items: center;

      .call-informations-wrapper {
        flex-grow: 1;

        .call-informations {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .estimated-waiting-time {
            max-width: 30%;
            padding-top: 5px;

            .time-unit {
              font-size: 1.75rem;
            }

            .time-unit-separator {
              padding-top: 5px;
            }

            .time-unit-desc {
              position: relative;
              font-size: 11px;
              top: -10px;
            }
          }
        }
      }

      .cancel-call-wrapper {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;

        #btn-cancel {
          width: 4rem;
          height: 4rem;
          border-radius: 2rem;
          background-color: #c5253a !important;

          .va-icon.fa-phone {
            transform: rotate(135deg) !important;
          }
        }
      }

    }

    &.active {
      background-color: $evollu-gray-dark;
      color: white;
      width: 35vw;
      padding-left: 3.5rem;
      flex-direction: column;
      justify-content: center;

      .call-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        .call-informations-wrapper {
          flex-grow: 1;

          .call-informations {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 1rem;

            .call-user {
              color: #c7c7c8;
            }

            .call-duration {
              font-size: 1.35rem;
              width: 25%;
              text-align: center;
            }
          }

          .call-actions {
            font-size: 13px;
            color: #6E6E6E;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 0.5rem;

            .call-action-buttons {
              display: flex;
              justify-content: space-between;
              width: 15%;
            }

            .v-popover:hover {
              color: #29c4a9;
            }

            i:not(.fa-warning) {
              font-size: 18px;
              cursor: pointer;
            }

            .near-end {
              color: #c49d29;
            }
          }
        }

        .end-call-wrapper {
          width: 30%;
          display: flex;
          justify-content: center;
          align-items: center;

          #btn-dismiss {
            width: 4rem;
            height: 4rem;
            border-radius: 2rem;
            background-color: #c5253a !important;

            .va-icon.fa-phone {
              transform: rotate(135deg) !important;
            }
          }
        }
      }

      .unsaved-changes-wrapper {
        padding-right: 2rem;
      }
    }

    @include mobile {
      &.pending, &.active {
        width: 100%;
        padding: 0.5rem;
      }

      &.default {
        width: 100%;
      }
    }

  }

  @include mobile {
    position: static;
    z-index: 0;
    top: auto;
    right: auto;
    border-radius: 3rem;
    margin-top: 1rem;
    margin-bottom: 1rem;

    .collapsable-div {
      display: none;
    }
  }

}
</style>
